import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { schema } from '../characterClassSkin.yup';
import DisplayFormikState from '~/components/DisplayFormikState/DisplayFormikState';
import Form from '../SkinForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateCharacterClassSkinApi } from '../characterClassSkinSlice';

function SkinUpdate({ edit, setEdit, editedSkin }) {
    const { id: characterClassId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onSubmit = async (values) => {
        try {
            dispatch(
                updateCharacterClassSkinApi({
                    characterClassId,
                    characterClassSkinId: values.id,
                    values,
                    navigate,
                }),
            );
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <Modal
            show={edit}
            onHide={() => {
                setEdit(false);
            }}
        >
            <ModalHeader></ModalHeader>
            <Formik
                initialValues={editedSkin}
                validateOnChange={false}
                validationSchema={schema(true, 1024 * 1024 * 20)} // largest size I noticed for the skin is 17MB
                onSubmit={onSubmit}
            >
                {(props) => {
                    // eslint-disable-next-line react/prop-types
                    const { isSubmitting, handleSubmit, values } = props;

                    return (
                        <>
                            <Modal.Body>
                                <Form values={values} />
                            </Modal.Body>
                            <ModalFooter
                                setEdit={setEdit}
                                handleSubmit={handleSubmit}
                                isSubmitting={isSubmitting}
                            ></ModalFooter>
                            <DisplayFormikState props={props} />
                        </>
                    );
                }}
            </Formik>
        </Modal>
    );
}

SkinUpdate.propTypes = {
    edit: PropTypes.bool.isRequired,
    setEdit: PropTypes.func.isRequired,
    editedSkin: PropTypes.object.isRequired,
};

export default SkinUpdate;

function ModalHeader() {
    return (
        <Modal.Header closeButton>
            <Modal.Title>Edit Skin </Modal.Title>
        </Modal.Header>
    );
}

function ModalFooter({ setEdit, handleSubmit, isSubmitting }) {
    return (
        <Modal.Footer>
            <Button
                variant="warning"
                onClick={() => setEdit(false)}
            >
                Close
            </Button>
            <Button
                variant="info"
                onClick={() => {
                    setEdit(false);
                    handleSubmit();
                }}
                disabled={isSubmitting}
            >
                Save Changes
            </Button>
        </Modal.Footer>
    );
}

ModalFooter.propTypes = {
    setEdit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
};
